export default __webpack_public_path__ + "static/media/MV.d6f24dce.svg";